import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { message } from 'antd'
import { addLabPatientDetails } from './LabAppointmentSlice'

export const bookLabAppointment = createAsyncThunk(
  'labAppointmentApi/bookLabAppointment',
  async (payload, { dispatch, rejectWithValue }) => {
    const formData = new FormData()

    formData.append('clinic_id', localStorage.getItem('clinic_id') || '')
    formData.append('title', `${payload?.title ?? ''}`)
    formData.append('patientName', `${payload?.name ?? ''}`)
    formData.append('patientAge', `${payload?.age ?? ''}`)
    formData.append('patientContactNumber', `${payload?.mobile ?? ''}`)
    formData.append('date', `${payload?.date ?? ''}`)
    formData.append('start_time', `${payload?.start_time ?? ''}`)
    formData.append('end_time', `${payload?.end_time ?? ''}`)
    formData.append('gender', `${payload?.gender ?? ''}`)
    formData.append('email', `${payload?.email ?? ''}`)
    formData.append('clinic_patient_id', `${payload?.clinic_patient_id ?? ''}`)
    formData.append('service_id', Array.isArray(payload?.procedureIds) ? payload.procedureIds.join(',') : '')
    formData.append('appointment_id', `${payload?.appointment_id ?? ''}`)
    formData.append('user_role', localStorage.getItem('user_role') ?? '')
    formData.append('loggedin_user_id', localStorage.getItem('user_id'))
    formData.append('MDT', 'CM')

    const response = await fetch(global.baseUrl + '/api/clinic_mobile_lab/Appointments/add', {
      method: 'POST',
      body: formData,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })

    const data = await response.json()

    if (data.status == '0') {
      return rejectWithValue(data.message || 'Something went wrong')
    }

    const refreshedToken = data?.response_token
    if (refreshedToken) {
      localStorage.setItem('token', refreshedToken)
    }

    dispatch(
      addLabPatientDetails({
        userAge: payload?.age,
        name: payload?.name,
        mobile: payload?.mobile,
        title: payload?.title,
        gender: payload?.gender,
        email: payload?.email,
      }),
    )

    message.success('Lab appointment booked successfully')

    return data
  },
)

export const addLabToQueue = createAsyncThunk(
  'labAppointmentApi/addLabToQueue',
  async (payload, { rejectWithValue }) => {
    const formData = new FormData()

    formData.append('clinic_id', localStorage.getItem('clinic_id') || '')
    formData.append('title', `${payload?.title ?? ''}`)
    formData.append('patientName', `${payload?.name ?? ''}`)
    formData.append('patientAge', `${payload?.age ?? ''}`)
    formData.append('patientContactNumber', `${payload?.mobile ?? ''}`)
    formData.append('date', `${payload?.date ?? ''}`)
    formData.append('gender', `${payload?.gender ?? ''}`)
    formData.append('email', `${payload?.email ?? ''}`)
    formData.append('clinic_patient_id', `${payload?.clinic_patient_id ?? ''}`)
    formData.append('service_id', Array.isArray(payload?.procedureIds) ? payload.procedureIds.join(',') : '')
    formData.append('appointment_id', `${payload?.appointment_id ?? ''}`)
    formData.append('user_role', localStorage.getItem('user_role') ?? '')
    formData.append('loggedin_user_id', localStorage.getItem('user_id'))
    formData.append('MDT', 'CM')

    const response = await fetch(global.baseUrl + '/api/clinic_mobile_lab/Appointments/add_to_queue', {
      method: 'POST',
      body: formData,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })

    const data = await response.json()

    if (data.status == '0') {
      return rejectWithValue(data.message || 'Something went wrong')
    }

    const refreshedToken = data?.response_token
    if (refreshedToken) {
      localStorage.setItem('token', refreshedToken)
    }

    return data
  },
)

const LabAppointmentApiSlice = createSlice({
  name: 'labAppointmentApi',
  initialState: {
    loading: false,
    queueLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(bookLabAppointment.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(bookLabAppointment.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || action.error.message
        alert(state.error)
      })
      .addCase(bookLabAppointment.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(addLabToQueue.pending, (state) => {
        state.queueLoading = true
        state.error = null
      })
      .addCase(addLabToQueue.rejected, (state, action) => {
        state.queueLoading = false
        state.error = action.payload || action.error.message
        alert(state.error)
      })
      .addCase(addLabToQueue.fulfilled, (state) => {
        state.queueLoading = false
      })
  },
})

export default LabAppointmentApiSlice.reducer